<template>
  <div class="login">
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
      <div class="login-logo"><img width="100" height="100" src="../assets/logo/logo.png" alt=""></div>
      <h3 class="title">碳软SCRM管理系统</h3>
      <el-form-item prop="username">
        <el-input v-model="loginForm.username" type="text" auto-complete="off" placeholder="手机号">
          <svg-icon slot="prefix" icon-class="user" class="el-input__icon input-icon" />
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="loginForm.password"
          type="password"
          auto-complete="off"
          placeholder="密码"
          @keyup.enter.native="handleLogin"
        >
          <svg-icon slot="prefix" icon-class="password" class="el-input__icon input-icon" />
        </el-input>
      </el-form-item>
      <el-form-item v-if="captchaEnabled" prop="code">
        <el-input
          v-model="loginForm.code"
          auto-complete="off"
          placeholder="验证码"
          @keyup.enter.native="handleLogin"
        >
          <svg-icon slot="prefix" icon-class="validCode" class="el-input__icon input-icon" />
        </el-input>
        <div class="login-code">
          <img :src="codeUrl" @click="getCode" class="login-code-img"/>
        </div>
      </el-form-item>
      <el-checkbox v-model="loginForm.rememberMe" style="margin:0px 0px 25px 0px;">记住密码</el-checkbox>
      <el-form-item style="width:100%;">
        <el-button
          :loading="loading"
          :disabled="loginDisabled"
          size="medium"
          type="primary"
          style="width:100%;"
          @click.native.prevent="handleLogin"
        >
          <span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span>
        </el-button>
      </el-form-item>
    </el-form>
    <!--  底部  -->
    <div class="el-login-footer">
      <span>©{{currentYear}}<a href="http://tanscrm.com"> 南京碳软信息科技有限公司 tanscrm.com 苏ICP备2021010465号</a></span>
    </div>
  </div>
</template>

<script>
import { getCodeImg } from "@/api/login";
import Cookies from "js-cookie";
import { encrypt, decrypt } from '@/utils/jsencrypt'

export default {
  name: "Login",
  data() {
    return {
      currentYear: new Date().getFullYear(),
      codeUrl: "",
      captchaEnabled: true,
      cookiePassword: "",
      loginForm: {
        username: "",
        password: "",
        rememberMe: false,
        code: "",
        uuid: ""
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", message: "手机号不能为空" }
        ],
        password: [
          { required: true, trigger: "blur", message: "密码不能为空" }
        ],
        code: [{ required: true, trigger: "change", message: "验证码不能为空" }]
      },
      loading: false,
      redirect: undefined
    };
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    },
  },
  computed: {
    loginDisabled() {
      const { username, password, code } = this.loginForm;
      return !(username && password && (!this.captchaEnabled || code));
    }
  },
  created() {
    this.getCode();
    this.getCookie();
  },
  methods: {
    getCode() {
      getCodeImg().then(res => {
        this.captchaEnabled = res.captchaEnabled !== false;
        if (this.captchaEnabled) {
          this.codeUrl = "data:image/gif;base64," + res.img;
          this.loginForm.uuid = res.uuid;
        } else {
          this.codeUrl = "";
          this.loginForm.code = "";
          this.loginForm.uuid = "";
        }
      });
    },
    getCookie() {
      const username = Cookies.get("username");
      const password = Cookies.get("password");
      const rememberMe = Cookies.get('rememberMe')
      this.loginForm = {
        username: username === undefined ? this.loginForm.username : username,
        password: password === undefined ? this.loginForm.password : decrypt(password),
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe)
      };
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.loginForm.rememberMe) {
            Cookies.set("username", this.loginForm.username, { expires: 30 });
            Cookies.set("password", encrypt(this.loginForm.password), { expires: 30 });
            Cookies.set('rememberMe', this.loginForm.rememberMe, { expires: 30 });
          } else {
            Cookies.remove("username");
            Cookies.remove("password");
            Cookies.remove('rememberMe');
          }
          this.$store
            .dispatch("Login", this.loginForm)
            .then(() => {
              this.$router.push({ path: this.redirect || "/" });
            })
            .catch(() => {
              this.loading = false;
              if (this.captchaEnabled) {
                this.getCode();
              }
            });
        }
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.login {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  &::before {
    content: " ";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-image: url("../assets/image/login-background.jpg");
    background-size: cover;
    filter: blur(2px);
  }

  &-logo {
    text-align: center;
    font-size: 0;
    margin: 0 0 8px;
  }

  .el-form-item--medium .el-form-item__content {
    display: flex;
  }
}
.title {
  margin: 0px auto 30px auto;
  text-align: center;
  color: #333;
  font-size: 20px;
}

.login-form {
  position: relative;
  border-radius: 6px;
  background: #ffffff;
  box-shadow: 0px 0px 40px 0px rgba(10, 56, 145, 0.302);
  width: 500px;
  padding: 25px 25px 5px 25px;
  z-index: 9;
  .el-input {
    height: 44px;
    input {
      height: 44px;
      font-size: 14px;
      color: #333;
    }
  }
  .input-icon {
    height: 44px;
    width: 14px;
    margin-left: 5px;
  }
  .el-button {
    border-radius: 22px;
    font-size: 16px;
    font-weight: 600;
    padding: 14px 0;
  }
}
.login-tip {
  font-size: 14px;
  text-align: center;
  color: #bfbfbf;
}
.login-code {
  flex: 0 0 124px;
  height: 44px;
  margin: 0 0 0 10px;
  overflow: hidden;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  box-shadow: inset 0 0 2px #666;
  img {
    margin: -2px;
    cursor: pointer;
    height: 48px;
    vertical-align: middle;
  }
}
.el-login-footer {
  height: 40px;
  line-height: 40px;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: #fff;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
}
.login-code-img {
  height: 44px;
}
</style>
